<template>
  <div :id="$style.dream_post_list">
    <dream-post-detail v-for="item in items" :key="item.id" :item="item"></dream-post-detail>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import DreamPostDetail from "@/components/molecules/DreamPostDetail.vue";

export default Vue.extend({
  name: "DreamPostList",
  components: {
    DreamPostDetail
  },
  props: {
    items: {
      type: Array
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #dream_post_list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    white-space: pre-line;
  }
}
@media only screen and (min-width: 1024px) {
  #dream_post_list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    white-space: pre-line;
  }
}
</style>

